/* eslint n/handle-callback-err: "error" */

import path from "ramda/src/path"
import pick from "ramda/src/pick"
import prop from "ramda/src/prop"

import _get from "lodash/get"
import { get, post, put, patch } from "services/network/endpoint"
import { success, dispatchHandler } from "services/utils/action"
import { setCustomer } from "services/network/auth"
import * as ActionTypes from "services/state/action-types"
import { setCookie, getCookie, getCookieAsJSON } from "services/utils/cookie"
import { toString } from "services/utils/date"
import { BFF_PUB, HTTP_CLIENT, BFF } from "services/network/routes"
import { EMAIL, FEBRABAN, INACTIVE } from "./constants"
import { saveOperation } from "../experience/action"

export function getCustomer() {
  return (dispatch) => {
    const config = { client: BFF }

    const request = get("customer", config)

    return dispatch({
      type: ActionTypes.GET_CUSTOMER,
      payload: request
    })
      .then((response) => {
        if (response && response.payload.data) {
          const data = response.payload.data
          const customerSegment = data.customerSegment
          if (
            customerSegment === "CORPORATIVO" ||
            customerSegment === "EMPRESARIAL"
          ) {
            dispatch(restoreLastCustomerUpdate())

            dispatch(restoreLastEmailUpdate())
          }

          const isConsultant = JSON.parse(
            window.localStorage.getItem("isConsultant")
          )
          const isConsultantLoginB2B =
            JSON.parse(window.localStorage.getItem("isConsultantLoginB2B")) ||
            false

          if (isConsultant && !isConsultantLoginB2B) {
            dispatch(
              saveOperation(
                response.payload.data,
                "",
                "LOGIN_CONSULTANT-SUCCESS",
                "LOGIN CONSULTOR",
                "SUCCESS",
                "",
                "SUCESSO LOGIN CONSULTOR"
              )
            )
          }
        }

        return response
      })
      .catch((error) => {
        console.error("[Error fetching customer data]", error)
      })
  }
}

function normalizeCustomer(data, customerState) {
  return {
    operationIndicator: "UPDATE_ALL",
    userLoggedEmail: data.email,
    sendingType: data.notificationMethod.value,
    site: data.site,
    smsPhoneNumber: data.sendingPhoneNumber || data.phoneNumber,
    phone: data.phone,
    targetCrm: customerState.data.customerCrm
  }
}

function normalizeReceivingProtocol(data) {
  return {
    operationIndicator: "SEND_PROTOCOL",
    userNotificationMethod: data.notificationMethod,
    userCommunication: data.smsPhoneNumber
  }
}

function restoreLastCustomerUpdate() {
  return (dispatch) => {
    const customerKey = getCookie("customerKey")
    const lastCustomerUpdate = getCookieAsJSON("lastCustomerUpdate")
    const date = prop(customerKey, lastCustomerUpdate)
    lastCustomerUpdate &&
      dispatch({
        type: ActionTypes.SET_LAST_CUSTOMER_UPDATE,
        payload: date
      })
  }
}

export function setLastCustomerUpdate(customerKey, date) {
  return (dispatch) => {
    const documentNumber = getCookie("customerKey")
    const lastCustomerUpdateDate = date || toString(new Date())
    const oldLastCustomerUpdate = getCookieAsJSON("lastCustomerUpdate") || {
      [documentNumber]: {}
    }
    const documentUpdate = {
      ...oldLastCustomerUpdate[documentNumber],
      [customerKey]: lastCustomerUpdateDate
    }
    const lastCustomerUpdate = {
      ...getCookieAsJSON("lastCustomerUpdate"),
      [documentNumber]: documentUpdate
    }

    setCookie("lastCustomerUpdate", { ...lastCustomerUpdate })

    dispatch({
      type: ActionTypes.SET_LAST_CUSTOMER_UPDATE,
      payload: lastCustomerUpdate[documentNumber]
    })
  }
}

function restoreLastEmailUpdate() {
  return (dispatch) => {
    const customerKey = getCookie("customerKey")
    const lastEmailUpdate = getCookieAsJSON("lastEmailUpdate")
    const date = prop(customerKey, lastEmailUpdate)

    lastEmailUpdate && dispatch(setLastEmailUpdate(date))
  }
}

export function setLastEmailUpdate(date) {
  return (dispatch) => {
    const documentNumber = getCookie("customerKey")
    const lastEmailUpdate = date || toString(new Date())

    setCookie("lastEmailUpdate", { [documentNumber]: lastEmailUpdate })

    dispatch({
      type: ActionTypes.SET_LAST_EMAIL_UPDATE,
      payload: lastEmailUpdate
    })
  }
}

export function updateCustomer(data) {
  return (dispatch, getState) => {
    const config = {
      data: normalizeCustomer(data, getState().customer),
      client: BFF
    }
    const request = put("customerEditData", config)

    return dispatch({
      type: ActionTypes.UPDATE_CUSTOMER,
      payload: request
    })
      .then((response) => {
        const protocol = _get(response, "payload.data.protocolNumber", "")

        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "REGISTER",
            "SUBMIT",
            "SUCCESS",
            protocol,
            "Dados Cadastrais"
          )
        )
      })
      .catch((error) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "REGISTER",
            "SUBMIT",
            "ERROR",
            "",
            "Dados Cadastrais"
          )
        )
      })
  }
}

export const updateReceivingProtocol = (data) => {
  return (dispatch) => {
    const config = { data: normalizeReceivingProtocol(data), client: BFF }
    const request = put("customer", config)

    return dispatch({
      type: ActionTypes.UPDATE_RECEIVING_PROTOCOL,
      payload: request
    })
  }
}

export function getContact(contactId) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.GET_CONTACT,
      payload: contactId
    })
  }
}

function normalizeContact(meta, data, state) {
  return {
    contact: pick(meta.fields, data),
    customerCrm: _get(state, "customer.data.customerCrm", ""),
    customerId: _get(state, "customer.data.customerId", "")
  }
}

export function createContact(data) {
  return (dispatch, getState) => {
    const config = { data, client: BFF }
    const request = put("createContact", config)

    return dispatch({
      type: ActionTypes.CREATE_CONTACT,
      payload: request
    })
      .then((request) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "REGISTER",
            "CONTACT_NEW",
            "SUCCESS",
            "",
            "Dados Cadastrais"
          )
        )
        return request
      })
      .catch((error) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "REGISTER",
            "CONTACT_NEW",
            "ERROR",
            "",
            "Dados Cadastrais"
          )
        )
        return error
      })
  }
}

export function updateContact(data) {
  return (dispatch, getState) => {
    const config = {
      data,
      client: BFF
    }
    const request = put("customerContactEditData", config)

    return dispatch({
      type: ActionTypes.UPDATE_CONTACT,
      payload: request
    })
      .then((response) => {
        const protocol = _get(response, "payload.data.protocolNumber", "")

        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "REGISTER",
            "CONTACT_EDIT",
            "SUCCESS",
            protocol,
            "Dados Cadastrais"
          )
        )

        if (!Reflect.has(response, "error")) {
          if (Reflect.has(data, "contactId"))
            dispatch(setLastCustomerUpdate(data.contactId))
        }
        return response
      })
      .catch((error) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "REGISTER",
            "CONTACT_EDIT",
            "ERROR",
            "",
            "Dados Cadastrais"
          )
        )
      })
  }
}

const REMOVE_CONTACT_PAYLOAD = {
  operationIndicator: "INACTIVATE_CONTACT",
  fields: ["contactId"]
}

export function removeContact(data, callback, callbackFail) {
  return (dispatch, getState) => {
    const config = {
      data: normalizeContact(REMOVE_CONTACT_PAYLOAD, data, getState())
    }
    const request = put("inactivateUserContact", config)

    return dispatch({
      type: ActionTypes.REMOVE_CONTACT,
      payload: request
    })
      .then((response) => {
        if (response.error) {
          dispatch(
            saveOperation(
              getState().customer.data,
              "",
              "REGISTER",
              "CONTACT_DELETE",
              "ERROR",
              "",
              "Dados Cadastrais"
            )
          )
          return callbackFail()
        }

        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "REGISTER",
            "CONTACT_DELETE",
            "SUCCESS",
            "",
            "Dados Cadastrais"
          )
        )

        return callback()
      })
      .catch((error) => {
        console.error(error)
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "REGISTER",
            "CONTACT_DELETE",
            "ERROR",
            "",
            "Dados Cadastrais"
          )
        )
      })
  }
}

function normalizeUser(meta, data, { customer: { contact } }) {
  return {
    operationIndicator: `B2B_${meta.operationIndicator}`,
    contacts: [
      {
        ...pick(meta.fields, contact),
        portalUser: data
      }
    ]
  }
}

const CREATE_USER_PAYLOAD = {
  operationIndicator: "CREATE_NEW_USER",
  fields: ["contactId", "sendingEmail", "documentNumber"]
}

export function createUser(data, callback) {
  return (dispatch, getState) => {
    const config = {
      data: normalizeUser(CREATE_USER_PAYLOAD, data, getState()),
      client: "portal/v1"
    }
    const request = post("users", config)

    return dispatch({
      type: ActionTypes.CREATE_USER,
      payload: request
    })
      .then((action) => {
        const {
          customer: { contact }
        } = getState()

        if (action.type === "CREATE_USER_FAIL") {
          dispatch(
            saveOperation(
              getState().customer.data,
              "",
              "REGISTER",
              "USER_NEW",
              "ERROR",
              "",
              "Dados Cadastrais"
            )
          )
        } else {
          dispatch(
            saveOperation(
              getState().customer.data,
              "",
              "REGISTER",
              "USER_NEW",
              "SUCCESS",
              "",
              "Dados Cadastrais"
            )
          )
        }

        dispatch(getContact(contact.contactId))
        callback && callback()
      })
      .catch((error) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "REGISTER",
            "USER_NEW",
            "ERROR",
            "",
            "Dados Cadastrais"
          )
        )
      })
  }
}

function normalizeUserActivationEmail(meta, data) {
  return {
    notificationType: "UPDATE_USER_B2B",
    sendType: "EMAIL",
    ...pick(meta.fields, data)
  }
}

const USER_ACTIVATION_EMAIL_PAYLOAD = {
  fields: ["userName", "documentNumber", "email"]
}

export function sendUserActivationEmail(data, callback) {
  return (dispatch, getState) => {
    const config = {
      data: normalizeUserActivationEmail(USER_ACTIVATION_EMAIL_PAYLOAD, data)
    }
    const request = post("sendUserActivationEmail", config)

    return dispatch({
      type: ActionTypes.SEND_USER_ACTIVATION_EMAIL,
      payload: request
    })
      .then((action) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "REGISTER",
            "USER_CONFIRMATION",
            "SUCCESS",
            "",
            "Dados Cadastrais"
          )
        )

        callback()
      })
      .catch((error) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "REGISTER",
            "USER_CONFIRMATION",
            "ERROR",
            "",
            "Dados Cadastrais"
          )
        )
      })
  }
}

export function selectCustomer(customerKey) {
  return (dispatch) => {
    setCustomer(customerKey)
    dispatch({ type: ActionTypes.CHANGE_CUSTOMER })
  }
}

export function signInSubsidiary(subsidiaryDocumentNumber) {
  return (dispatch) => {
    const config = { data: { subsidiaryDocumentNumber } }

    const request = post("signInSubsidiary", config)

    return dispatch({
      type: ActionTypes.SIGN_IN_SUBSIDIARY,
      payload: request
    })
  }
}

export function sendMail(data, callback, callbackFail) {
  return (dispatch) => {
    const config = { data }
    const request = post("sendMail", config)

    dispatch({
      type: ActionTypes.SEND_MAIL,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getAddressByZipCode(zipCode, callback, callbackFail) {
  return (dispatch) => {
    const config = { pathValues: { zipCode }, client: BFF_PUB }
    const request = get("zipCode", config)

    return dispatch({
      type: ActionTypes.ZIP_CODE_ADDRESS,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function findAddress(zipCode) {
  return (dispatch) => {
    const config = { pathValues: { zipCode }, client: BFF_PUB }
    const request = get("zipCode", config)

    return dispatch({
      type: ActionTypes.GET_ADDRESS_BY_ZIPCODE,
      payload: request
    }).then(
      success((action) => {
        const { payload } = action

        if (path(["data", "resultCode"], payload) === "error") {
          return dispatch({ type: "RESET_ADDRESS" })
        }

        return dispatch({
          type: ActionTypes.SET_ADDRESS_BY_ZIPCODE,
          payload
        })
      })
    )
  }
}

export const clearSelecteds = () => ({
  type: ActionTypes.CLEAR_ADDRESS_SELECTEDS
})

export const clearZipCode = () => ({
  type: ActionTypes.CLEAR_ADDRESS_ZIPCODE
})

export const updateAddressLocality = (payload) => ({
  type: ActionTypes.UPDATE_ADDRESS_LOCALITY,
  payload
})

export const updateAddressStreet = (payload) => ({
  type: ActionTypes.UPDATE_ADDRESS_STREET,
  payload
})

export function getTypeComplement() {
  return (dispatch) => {
    const request = get("getTypeComplement")

    dispatch({
      type: ActionTypes.GET_TYPE_COMPLEMENT,
      payload: request
    })
  }
}

export function getAddress() {
  return (dispatch, getState) => {
    const accountNumber = getState().bills.selected.accountNumber
    const request = get("address", { pathValues: { accountNumber } })

    dispatch({
      type: ActionTypes.GET_ADDRESS,
      payload: request
    })
  }
}

export function updateAddress(value) {
  return (dispatch, getState) => {
    const agreementId = getState().bills.selected.agreementId
    const config = {
      data: value,
      pathValues: { agreementId },
      raw: true,
      client: BFF
    }
    const request = put("updateAddress", config)

    return dispatch({
      type: ActionTypes.UPDATE_ADDRESS,
      payload: request
    })
  }
}

export function updateBill(data, name) {
  return (dispatch, getState) => {
    const config = { data }
    const request = put("updateBillSendType", config)

    return dispatch({
      type: ActionTypes.UPDATE_BILL,
      payload: request,
      name
    })
  }
}

function normalizeBill(bill, values) {
  return {
    ...bill,
    febrabanSendType: values.febraban,
    email:
      values.receipt === EMAIL || values.receipt === FEBRABAN
        ? values.email
        : bill.email || ""
  }
}

function normalizeAddress(values, getState) {
  function findAddressById() {
    return getState().modal.data.streetName.filter((address) => {
      return address.value === values.address
    })
  }

  const addressComplements = []

  const [address] = findAddressById()
  const [neighborhood] = getState().modal.data.neighborhood
  const [locality] = getState().modal.data.locality
  const [federativeUnit] = getState().modal.data.federativeUnit

  values.complement01 &&
    addressComplements.push({
      description: values.complement01,
      type: values.complementType01
    })

  values.complement02 &&
    addressComplements.push({
      description: values.complement02,
      type: values.complementType02
    })

  values.complement03 &&
    addressComplements.push({
      description: values.complement03,
      type: values.complementType03
    })

  const data = {
    id: locality.value,
    zipCode: values.zipCode,
    federativeUnit: federativeUnit.label,
    city: locality.label,
    locality: locality.name,

    streetTypeCode: address.streetTypeCode,
    streetType: address.streetType,
    street: address.name,

    neighborhood: neighborhood.label,
    number: values.number,

    nameTypeCode: address.nameType,
    country: "Brasil",

    addressComplements
  }
  return data
}

function isFebrabanDeactivation({ receipt, febraban }) {
  return receipt === EMAIL && febraban === INACTIVE
}

function getFebrabanDeactivationPayload(bill, selected, values) {
  const { email } = values

  return {
    active: { ...selected, email },
    deactive: bill
  }
}

function getReceivingTypePayload(bill, values) {
  return {
    active: {
      sendTypeModify: values.receipt,
      email: bill.email,
      targetCrm: bill.targetCrm,
      billingSystem: bill.billingSystem,
      billingAccountNumber: bill.accountNumber
    }
  }
}

function normalizeReceivingType(bill, selected, values) {
  return isFebrabanDeactivation(values)
    ? getFebrabanDeactivationPayload(bill, selected, values)
    : getReceivingTypePayload(bill, values)
}

const warningResponse = [
  "lock.restriction.error",
  "os.already.open.noprotocol",
  "os.double.request",
  "lock.restriction.not.change",
  "type.not.allowed",
  "business.user.warning"
]

export function updateReceivingType(values, callback) {
  return (dispatch, getState) => {
    const { selected } = getState().bills
    const bill = normalizeBill(selected, values)
    const receivingType = normalizeReceivingType(bill, selected, values)

    dispatch(updateBill(receivingType, "type")).then((response) => {
      let sendType

      if (values.receipt === "CONTA_EMAIL") {
        sendType = "ONLINE"
      } else if (values.receipt === "CONTA_CORREIO") {
        sendType = "POST_OFFICE"
      }

      if (!response.error) {
        let protocol

        if (!!response && !!response.payload && response.payload.length > 0) {
          protocol = response.payload[0].protocolNumber
        }

        dispatch(
          saveOperation(
            getState().customer.data,
            bill.accountNumber,
            "ACCOUNT_DELIVERY_TYPE",
            sendType,
            "SUCCESS",
            protocol,
            "Método de envio de conta"
          )
        )

        if (
          values.receipt === "CONTA_CORREIO" &&
          Object.keys(values).length > 1
        ) {
          const address = normalizeAddress(values, getState)
          dispatch(updateAddress(address)).then(() => callback())
        } else {
          callback()
        }
      } else {
        const errorResponse = response.error || response
        const stIntegrity =
          errorResponse.response &&
          errorResponse.response.data &&
          errorResponse.response.data.messageKey &&
          warningResponse.indexOf(errorResponse.response.data.messageKey) > -1
            ? "WARNING"
            : "ERROR"

        dispatch(
          saveOperation(
            getState().customer.data,
            bill.accountNumber,
            "ACCOUNT_DELIVERY_TYPE",
            sendType,
            stIntegrity,
            "",
            "Método de envio de conta"
          )
        )
      }
    })
  }
}

export function updateReceivingTypeFebraban(values, selectedBill, callback) {
  return (dispatch, getState) => {
    const { selected } = getState().bills
    const bill = normalizeBill(selected, values)
    const receivingType = normalizeReceivingType(bill, selected, values)

    dispatch(updateBill(receivingType, "febraban"))
      .then((response) => {
        let status, protocol

        if (response.type === "UPDATE_BILL_FAIL") {
          status = "ERROR"
          const stIntegrity =
            response.error.response.data.messageKey &&
            warningResponse.indexOf(response.error.response.data.messageKey) >
              -1
              ? "WARNING"
              : "ERROR"
          status = stIntegrity
        } else {
          status = "SUCCESS"
        }

        if (!!response && !!response.payload && response.payload.length > 0) {
          protocol = response.payload[0].protocolNumber
        }

        dispatch(
          saveOperation(
            getState().customer.data,
            selectedBill.accountNumber,
            "ACCOUNT_DELIVERY_TYPE",
            "FEBRABAN",
            status,
            protocol,
            "Método de envio de conta"
          )
        )

        callback()
      })
      .catch((response) => {
        const errorResponse = response.error || response
        const stIntegrity =
          errorResponse.response &&
          errorResponse.response.data &&
          errorResponse.response.data.messageKey &&
          warningResponse.indexOf(errorResponse.response.data.messageKey) > -1
            ? "WARNING"
            : "ERROR"

        dispatch(
          saveOperation(
            getState().customer.data,
            selectedBill.accountNumber,
            "ACCOUNT_DELIVERY_TYPE",
            "FEBRABAN",
            stIntegrity,
            "",
            "Método de envio de conta"
          )
        )
      })
  }
}

export function showModal() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.OPEN_MODAL,
      payload: true
    })
  }
}

export function closeModal() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.CLOSE_MODAL
    })
  }
}

export function setModalCustomer() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_MODAL_CUSTOMER
    })
  }
}

export function resetErrorEditCustomer() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.RESET_ERROR_EDIT_CUSTOMER
    })
  }
}

export function getSubscription(callback, callbackFail) {
  return (dispatch, getState) => {
    const customerId = _get(getState().customer, "data.documentNumber", "")
    const config = { pathValues: { customerId }, client: "sensedia" }
    const request = get("getSubscription", config)
    return dispatch({
      type: ActionTypes.GET_SUBSCRIPTION,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function validatePassword(password) {
  return (dispatch) => {
    const config = {
      data: {
        userLoggedPassword: password
      },
      client: BFF
    }
    const request = put("userValidatePassword", config)

    return dispatch({
      type: ActionTypes.VALIDATE_CUSTOMER_PASSWORD,
      payload: request,
      load: { loading: true }
    })
      .then((response) => response)
      .catch((error) => error)
  }
}

export function changePassword({
  newPassword,
  customerSegment,
  email,
  userLogged
}) {
  return (dispatch, getState) => {
    const config = {
      data: {
        userLogged,
        userLoggedPassword: newPassword,
        email,
        customerSegment
      },
      client: BFF
    }
    const request = put("userChangePassword", config)

    return dispatch({
      type: ActionTypes.CHANGE_CUSTOMER_PASSWORD,
      payload: request,
      load: { loading: true }
    })
      .then((response) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "CHANGE_PASSWORD",
            "SUBMIT",
            "SUCCESS",
            "",
            "Alteração de Senha"
          )
        )
        return response
      })
      .catch((error) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "CHANGE_PASSWORD",
            "SUBMIT",
            "ERROR",
            "",
            "Alteração de Senha"
          )
        )

        return error
      })
  }
}

export const saveDigitalAccountDeactivationReasearch = (data) => {
  return (dispatch, getState) => {
    const cpfCnpj = _get(getState().customer, "data.documentNumber", "")
    const name = _get(getState().customer, "data.name", "")
    const segment = _get(getState().customer, "data.customerSegment", "")
    const dateTime = new Date().toLocaleString("pt-BR", {
      timeZone: "America/SAO_PAULO"
    })

    const config = {
      client: HTTP_CLIENT,
      params: {
        dateTime,
        name,
        cpfCnpj,
        segment,
        source: "B2B",
        productId: data.billingAccountNumber,
        reason: data.customReason || data.reason
      }
    }
    const request = get("gSheetsAccountDeactivationResearch", config)

    dispatch({
      type: ActionTypes.DEACTIVATE_DIGITAL_ACCOUNT,
      payload: request
    }).catch(function (err) {
      console.error("error: ", err)
    })
  }
}

export function getCustomerTickets() {
  return (dispatch, getState) => {
    const customerId = _get(getState().customer, "data.customerId", "")
    const config = {
      pathValues: { customerId },
      client: BFF
    }
    const request = get("getCustomerTickets", config)
    return dispatch({
      type: ActionTypes.FIND_CUSTOMER_TICKETS,
      payload: request
    })
      .then((response) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "FIND_CUSTOMER_TICKETS",
            "VIEW",
            "SUCCESS",
            "",
            "Algar Sempre"
          )
        )
        return response
      })
      .catch((error) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "FIND_CUSTOMER_TICKETS",
            "VIEW",
            "ERROR",
            "",
            "Algar Sempre"
          )
        )

        console.error(error)
      })
  }
}

export function findCustomerOpenInvoices() {
  return (dispatch, getState) => {
    const customerKey = getCookie("customerKey")
    const config = {
      pathValues: { customerKey },
      useMock: false,
      client: BFF
    }

    const request = get("newGetOpenInvoices", config)

    return dispatch({
      type: ActionTypes.FIND_CUSTOMER_OPEN_INVOICES,
      payload: request
    })
      .then((response) => {
        saveOperation(
          getState().customer.data,
          "",
          "INVOICE",
          "VIEW",
          "SUCCESS",
          "",
          "Listagem de faturas"
        )
        return response
      })
      .catch((e) => {
        saveOperation(
          getState().customer.data,
          "",
          "INVOICE",
          "VIEW",
          "ERROR",
          "",
          "Listagem de faturas"
        )
      })
  }
}

export function filterInvoicesByService(serviceId) {
  return (dispatch) => {
    const config = {
      pathValues: { serviceId },
      client: BFF
    }
    const request = get("filter", config)
    return dispatch({
      type: ActionTypes.FILTER_INVOICES,
      payload: request
    })
  }
}

export function createMultiUser(payload, callback, callbackFail) {
  return (dispatch) => {
    const config = { data: payload, client: BFF }
    const request = post("multiUser", config)

    return dispatch({
      type: ActionTypes.CREATE_MULTI_USER,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}
export function disableMultiUser(payload, callback, callbackFail) {
  return (dispatch) => {
    const config = { data: payload, client: BFF }
    const request = post("disableMultiUser", config)

    return dispatch({
      type: ActionTypes.DISABLE_MULTI_USER,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function activeMultiUser(payload, callback, callbackFail) {
  return (dispatch) => {
    const config = { data: payload, client: BFF }
    const request = patch("activeMultiUser", config)

    return dispatch({
      type: ActionTypes.ACTIVE_MULTI_USER,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function listNotificationMethods() {
  return (dispatch, getState) => {
    const config = {
      data: { key: "NOTIFICATION_METHOD", parentId: 262 },
      client: BFF
    }
    const request = post("listConfigValues", config)

    return dispatch({
      type: ActionTypes.LIST_CONFIG_VALUES,
      payload: request
    })
  }
}

export function listModem(data) {
  return (dispatch) => {
    const config = { data, client: BFF }
    const request = post("listModem", config)

    return dispatch({
      type: "LIST_MODEM",
      payload: request
    })
  }
}

export function resetModem(data) {
  return (dispatch) => {
    const config = { data, client: BFF }
    const request = post("resetModem", config)

    return dispatch({
      type: "RESET_MODEM",
      payload: request
    })
  }
}

export function updateNotificationMethods(data) {
  return (dispatch, getState) => {
    const config = {
      data,
      client: BFF
    }
    const request = post("updateNotificationMethods", config)

    return dispatch({
      type: ActionTypes.UPDATE_CUSTOMER,
      payload: request
    })
      .then((response) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "REGISTER",
            "SUBMIT",
            "SUCCESS",
            "",
            "Dados Cadastrais"
          )
        )
        return response
      })
      .catch((error) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "REGISTER",
            "SUBMIT",
            "ERROR",
            "",
            "Dados Cadastrais"
          )
        )

        throw error
      })
  }
}

export function getSubsidiaryDetails(
  documentNumberSubsidiary,
  callback,
  callbackError
) {
  return (dispatch) => {
    const config = {
      pathValues: { documentNumberSubsidiary },
      client: BFF
    }
    const request = get("getSubsidiaryDetails", config)

    return dispatch({
      type: ActionTypes.GET_SUBSIDIARY_DETAILS,
      payload: request
    }).then(dispatchHandler(callback, callbackError))
  }
}

export function getValidateConglomerates(callback, callbackFail) {
  return (dispatch) => {
    const config = {
      client: BFF
    }
    const request = get("getValidateConglomerates", config)

    return dispatch({
      type: ActionTypes.VALIDATE_CONGLOMERATES,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function validateBeegolAccessAvailability(callback, callbackFail) {
  return (dispatch) => {
    const config = {
      client: BFF
    }
    const request = get("validateBeegolAccessAvailability", config)

    return dispatch({
      type: ActionTypes.VALIDATE_BEEGOL_ACCESS_AVAILABILITY,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}



// WEBPACK FOOTER //
// ./src/services/state/customer/action.js